// Client-side payment ledger helpers. Server-side verification lives in
// supabase/functions/verify-paystack (uses PAYSTACK_SECRET_KEY, never exposed here).
import { supabase } from '../integrations/supabase/client';
import { enrollInCourse } from './lms';

export async function recordPendingPayment(args: { ref: string; userId: string | null; courseId: string; amount: number; email: string }) {
  // userId may be null for guest checkout (Paystack-first flow) — store row only when logged in.
  if (!args.userId) return;
  try {
    await supabase.from('payments').upsert(
      { id: args.ref, user_id: args.userId, course_id: args.courseId, amount: args.amount, currency: 'NGN', status: 'pending', provider: 'paystack' },
      { onConflict: 'id' }
    );
  } catch {
    /* table may not exist until migration runs — non-fatal */
  }
}

export async function confirmPaymentClientSide(args: { ref: string; userId: string | null; courseId: string; amount: number }) {
  // Local fallback for free/legacy flows only. Paid entitlements are created by the
  // verify-paystack Edge Function; RLS rejects client writes for paid courses.
  if (!args.userId) return;
  try {
    await supabase.from('payments').upsert(
      { id: args.ref, user_id: args.userId, course_id: args.courseId, amount: args.amount, currency: 'NGN', status: 'completed', provider: 'paystack' },
      { onConflict: 'id' }
    );
  } catch {
    /* ignore */
  }
  try {
    await enrollInCourse(args.userId, args.courseId, args.ref);
  } catch {
    /* ignore */
  }
}

export interface VerifyPaymentResult {
  ok: boolean;
  message: string;
  invited?: boolean;
  emailSent?: boolean;
  email?: string;
  amount?: number;
  courseId?: string | null;
  courses?: string[];
}

export async function verifyPaymentServerSide(ref: string): Promise<VerifyPaymentResult> {
  try {
    const { data, error } = await supabase.functions.invoke('verify-paystack', { body: { reference: ref } });
    if (error) return { ok: false, message: error.message };
    return data as VerifyPaymentResult;
  } catch (e) {
    return { ok: false, message: e instanceof Error ? e.message : 'Verification failed' };
  }
}
